import { template } from "@ember/template-compiler";
import type { TOC } from '@ember/component/template-only';
export const ExternalLink: TOC<{
    Element: HTMLAnchorElement;
    Blocks: {
        default: [];
    };
}> = template(`
  <a target="_blank" rel="noreferrer noopener" href="##missing##" ...attributes>
    {{yield}}
  </a>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default ExternalLink;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL2VtYmVyLXByaW1pdGl2ZXMvZW1iZXItcHJpbWl0aXZlcy9lbWJlci1wcmltaXRpdmVzL3NyYy9jb21wb25lbnRzL2V4dGVybmFsLWxpbmsuZ3RzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB0eXBlIHsgVE9DIH0gZnJvbSAnQGVtYmVyL2NvbXBvbmVudC90ZW1wbGF0ZS1vbmx5JztcblxuZXhwb3J0IGNvbnN0IEV4dGVybmFsTGluazogVE9DPHtcbiAgRWxlbWVudDogSFRNTEFuY2hvckVsZW1lbnQ7XG4gIEJsb2Nrczoge1xuICAgIGRlZmF1bHQ6IFtdO1xuICB9O1xufT4gPSA8dGVtcGxhdGU-XG4gIDxhIHRhcmdldD1cIl9ibGFua1wiIHJlbD1cIm5vcmVmZXJyZXIgbm9vcGVuZXJcIiBocmVmPVwiIyNtaXNzaW5nIyNcIiAuLi5hdHRyaWJ1dGVzPlxuICAgIHt7eWllbGR9fVxuICA8L2E-XG48L3RlbXBsYXRlPjtcblxuZXhwb3J0IGRlZmF1bHQgRXh0ZXJuYWxMaW5rO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxjQUFjLEdBQUcsUUFBUSxpQ0FBaUM7QUFFMUQsT0FBTyxNQUFNLGNBQWM7SUFDekIsU0FBUztJQUNUO1FBQ0U7O0tBRUMsU0FBVSxDQUFBOzs7O0FBSWYsQ0FBQSxFQUFBO0lBQUE7UUFBQSxPQUFBLEtBQUEsU0FBQSxDQUFBLEVBQVc7SUFBRDtBQUFBLEdBQUU7QUFFWixlQUFlLGFBQWEifQ